import { useQuery } from '@tanstack/react-query';

import { datahubAxiosClient, SALES_PRODUCT_ENDPOINT } from 'constants/server/apiEndPoint';
import { ORDER_CREATION_PACKAGE_TYPE } from 'constants/ui/status';
import { IProductDto } from './dto';
import { useToastMessageCopyable } from 'hooks/general/useToastMessageCopyable';
import { useLocalization } from 'localization';

type SaleProductsParams = {
  branchId: string;
  pageNumber: number;
  type?: ORDER_CREATION_PACKAGE_TYPE;
  squareMeter?: number;
  propertyType?: string;
  includeAccountNumberFilter?: boolean;
};

export const productsQueryKey = {
  all: ['products'] as const,
  saleProducts: (params: SaleProductsParams) => [params, 'saleProducts'] as const,
};

export const getSaleProductsApi = (params: SaleProductsParams) => {
  const { branchId, type, pageNumber, squareMeter, propertyType, includeAccountNumberFilter = false } = params;
  const { t } = useLocalization();
  const querySaleProducts = useQuery<IProductDto[]>({
    queryKey: productsQueryKey.saleProducts(params),
    queryFn: async () => {
      const response = await datahubAxiosClient.get(SALES_PRODUCT_ENDPOINT, {
        params: {
          branchId,
          type,
          pageNumber,
          squareMeter,
          propertyType,
          includeAccountNumberFilter,
        },
      });
      return response.data;
    },
    // TODO: onError was removed in @tanstack/react-query v5 -- handle error display via useEffect or error boundary
    enabled: !!branchId,
  });

  return querySaleProducts;
};
